import PropTypes from "prop-types";
import ProductSelect from "../ProductSelect";
import getOptions from "./getOptions";
import content from "app-content";

const ProductColourSelect = ({
  isOneColour,
  colourWayId,
  variants,
  isForceDisabled,
  onChange
}) => (
  <ProductSelect
    options={getOptions(variants)}
    label={content.saved_items_accessibility_colour_picker}
    disabled={isForceDisabled || isOneColour}
    value={`${colourWayId}`}
    onChange={onChange}
  />
);

ProductColourSelect.propTypes = {
  isOneColour: PropTypes.bool.isRequired,
  colourWayId: PropTypes.number.isRequired,
  variants: PropTypes.arrayOf(
    PropTypes.shape({
      colour: PropTypes.string.isRequired,
      price: PropTypes.object.isRequired,
      isVariantInStock: PropTypes.bool.isRequired,
      colourWayId: PropTypes.number.isRequired
    })
  ).isRequired,
  isForceDisabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};

export default ProductColourSelect;
